var map = {
	"./": 57,
	"./App": 94,
	"./App.js": 94,
	"./assets/floorplans/Syd-Rental_Floorplans_Aug19_2022.pdf": 437,
	"./assets/floorplans/plans/a.png": 438,
	"./assets/floorplans/plans/b.png": 439,
	"./assets/floorplans/plans/b7.png": 440,
	"./assets/floorplans/plans/c.png": 441,
	"./assets/floorplans/plans/d.png": 442,
	"./assets/floorplans/plans/f.png": 443,
	"./assets/floorplans/plans/g.png": 444,
	"./assets/floorplans/plans/h.png": 445,
	"./assets/floorplans/plans/i.png": 446,
	"./assets/floorplans/plans/k.png": 447,
	"./assets/floorplans/plans/l.png": 448,
	"./assets/floorplans/plans/n.png": 449,
	"./assets/floorplans/plans/o.png": 450,
	"./assets/floorplans/plans/p.png": 451,
	"./assets/floorplans/plans/q.png": 452,
	"./assets/floorplans/plans/r.png": 453,
	"./assets/floorplans/thumbs/a.svg": 454,
	"./assets/floorplans/thumbs/b.svg": 455,
	"./assets/floorplans/thumbs/b7.svg": 456,
	"./assets/floorplans/thumbs/c.svg": 457,
	"./assets/floorplans/thumbs/d.svg": 458,
	"./assets/floorplans/thumbs/f.svg": 459,
	"./assets/floorplans/thumbs/g.svg": 460,
	"./assets/floorplans/thumbs/h.svg": 461,
	"./assets/floorplans/thumbs/i.svg": 462,
	"./assets/floorplans/thumbs/k.svg": 463,
	"./assets/floorplans/thumbs/l.svg": 464,
	"./assets/floorplans/thumbs/n.svg": 465,
	"./assets/floorplans/thumbs/o.svg": 466,
	"./assets/floorplans/thumbs/p.svg": 467,
	"./assets/floorplans/thumbs/q.svg": 468,
	"./assets/floorplans/thumbs/r.svg": 469,
	"./assets/fonts/Gotham-Bold.woff": 470,
	"./assets/fonts/Gotham-Bold.woff2": 471,
	"./assets/fonts/Gotham-BoldItalic.woff": 472,
	"./assets/fonts/Gotham-BoldItalic.woff2": 473,
	"./assets/fonts/Gotham-Book.woff": 474,
	"./assets/fonts/Gotham-Book.woff2": 475,
	"./assets/fonts/Gotham-BookItalic.woff": 476,
	"./assets/fonts/Gotham-BookItalic.woff2": 477,
	"./assets/fonts/Gotham-Light.woff": 478,
	"./assets/fonts/Gotham-Light.woff2": 479,
	"./assets/fonts/Gotham-LightItalic.woff": 480,
	"./assets/fonts/Gotham-LightItalic.woff2": 481,
	"./assets/fonts/Gotham-Medium.woff": 482,
	"./assets/fonts/Gotham-Medium.woff2": 483,
	"./assets/fonts/Gotham-MediumItalic.woff": 484,
	"./assets/fonts/Gotham-MediumItalic.woff2": 485,
	"./assets/fonts/Kessel105-Bold.woff": 486,
	"./assets/fonts/Kessel105-Bold.woff2": 487,
	"./assets/fonts/Kessel105-Book.woff": 488,
	"./assets/fonts/Kessel105-Book.woff2": 489,
	"./assets/fonts/Kessel105-Light.woff": 490,
	"./assets/fonts/Kessel105-Light.woff2": 491,
	"./assets/images/_global/bookappointment.svg": 492,
	"./assets/images/_global/footer-map.png": 177,
	"./assets/images/_global/icons/Ledmac_Wechat_Qr_Code_Banner.jpeg": 184,
	"./assets/images/_global/icons/Triangle@2x.png": 493,
	"./assets/images/_global/icons/arrow-left.svg": 135,
	"./assets/images/_global/icons/arrow-right.svg": 136,
	"./assets/images/_global/icons/arrow_left.svg": 494,
	"./assets/images/_global/icons/arrow_left@2x.png": 495,
	"./assets/images/_global/icons/arrow_right.svg": 496,
	"./assets/images/_global/icons/arrow_right@2x.png": 497,
	"./assets/images/_global/icons/calendar.png": 498,
	"./assets/images/_global/icons/calendar.svg": 148,
	"./assets/images/_global/icons/carousel-arrow-left.png": 499,
	"./assets/images/_global/icons/carousel-arrow-left.svg": 186,
	"./assets/images/_global/icons/carousel-arrow-left@2x.png": 500,
	"./assets/images/_global/icons/carousel-arrow-right.png": 501,
	"./assets/images/_global/icons/carousel-arrow-right.svg": 187,
	"./assets/images/_global/icons/carousel-arrow@2x.png": 502,
	"./assets/images/_global/icons/checkmark.svg": 503,
	"./assets/images/_global/icons/close.svg": 149,
	"./assets/images/_global/icons/icon-facebook.png": 179,
	"./assets/images/_global/icons/icon-instagram.png": 182,
	"./assets/images/_global/icons/icon-linkedin.png": 183,
	"./assets/images/_global/icons/icon-twitter.png": 180,
	"./assets/images/_global/icons/icon-weixin.png": 178,
	"./assets/images/_global/icons/icon-youtube.png": 181,
	"./assets/images/_global/icons/open_modal.svg": 188,
	"./assets/images/_global/icons/select-down.svg": 189,
	"./assets/images/_global/icons/wechat-close-icon.png": 185,
	"./assets/images/_global/logos/header_logo.png": 504,
	"./assets/images/_global/logos/ledmac-logo.svg": 134,
	"./assets/images/_global/logos/logo-precidia-rentals-green.png": 505,
	"./assets/images/_global/logos/logo-precidia-rentals-green.svg": 176,
	"./assets/images/_global/logos/logo-precidia-rentals-white.png": 133,
	"./assets/images/_global/logos/logo-precidia-rentals-white.svg": 190,
	"./assets/images/_global/logos/logo-precidia-rentals.svg": 506,
	"./assets/images/_global/pattern_left.svg": 507,
	"./assets/images/_global/pattern_right.svg": 508,
	"./assets/images/building/building-exterior.jpg": 191,
	"./assets/images/building/fitness-centre.jpg": 137,
	"./assets/images/building/lounge.jpg": 192,
	"./assets/images/building/outdoor-terrace.jpg": 193,
	"./assets/images/developer/ledmac_tagline.svg": 194,
	"./assets/images/developer/logo_ibi.png": 195,
	"./assets/images/developer/logo_pwl.png": 196,
	"./assets/images/developer/logo_themill.png": 197,
	"./assets/images/developer/projects/01_escala-burnaby.jpg": 60,
	"./assets/images/developer/projects/02_aviara-burnaby.jpg": 61,
	"./assets/images/developer/projects/03_reflections-burnaby.jpg": 62,
	"./assets/images/developer/projects/04_waterscapes-kelowna.jpg": 63,
	"./assets/images/developer/projects/05_highpoint-coquitlam.jpg": 64,
	"./assets/images/developer/projects/06_icon-burnaby.jpg": 65,
	"./assets/images/developer/projects/07_sydney-coquitlam.jpg": 59,
	"./assets/images/developer/projects/08_azure-burnaby.jpg": 66,
	"./assets/images/developer/projects/09_northgate_village-burnaby.jpg": 67,
	"./assets/images/developer/projects/10_perspectives-burnaby.jpg": 68,
	"./assets/images/developer/projects/11_saltaire-white_rock.jpg": 69,
	"./assets/images/developer/projects/12_dominion-new_westminster.jpg": 70,
	"./assets/images/floorplans/accordion_down.svg": 509,
	"./assets/images/floorplans/accordion_down@2x.png": 510,
	"./assets/images/floorplans/accordion_up.svg": 511,
	"./assets/images/floorplans/accordion_up@2x.png": 512,
	"./assets/images/floorplans/keyplates/A.png": 198,
	"./assets/images/floorplans/keyplates/B2.png": 199,
	"./assets/images/floorplans/keyplates/C2.png": 200,
	"./assets/images/floorplans/keyplates/D.png": 201,
	"./assets/images/floorplans/keyplates/E.png": 202,
	"./assets/images/floorplans/keyplates/F.png": 203,
	"./assets/images/floorplans/keyplates/G.png": 204,
	"./assets/images/floorplans/keyplates/J.png": 205,
	"./assets/images/floorplans/keyplates/K.png": 206,
	"./assets/images/floorplans/keyplates/M.png": 207,
	"./assets/images/floorplans/keyplates/O.png": 208,
	"./assets/images/floorplans/keyplates/P.png": 209,
	"./assets/images/floorplans/keyplates/R.png": 210,
	"./assets/images/floorplans/keyplates/S.png": 211,
	"./assets/images/floorplans/keyplates/T.png": 212,
	"./assets/images/floorplans/keyplates/W.png": 213,
	"./assets/images/floorplans/keyplates/X.png": 214,
	"./assets/images/floorplans/north.svg": 513,
	"./assets/images/floorplans/plans/A.png": 215,
	"./assets/images/floorplans/plans/B2.png": 216,
	"./assets/images/floorplans/plans/C2.png": 217,
	"./assets/images/floorplans/plans/D.png": 218,
	"./assets/images/floorplans/plans/E.png": 219,
	"./assets/images/floorplans/plans/F.png": 220,
	"./assets/images/floorplans/plans/G.png": 221,
	"./assets/images/floorplans/plans/J.png": 222,
	"./assets/images/floorplans/plans/K.png": 223,
	"./assets/images/floorplans/plans/M.png": 224,
	"./assets/images/floorplans/plans/O.png": 225,
	"./assets/images/floorplans/plans/P.png": 226,
	"./assets/images/floorplans/plans/R.png": 227,
	"./assets/images/floorplans/plans/S.png": 228,
	"./assets/images/floorplans/plans/T.png": 229,
	"./assets/images/floorplans/plans/W.png": 230,
	"./assets/images/floorplans/plans/X.png": 231,
	"./assets/images/gallery/hero.jpg": 232,
	"./assets/images/gallery/interiors/ensuite.png": 233,
	"./assets/images/gallery/interiors/fitness-centre.png": 234,
	"./assets/images/gallery/interiors/kitchen.png": 235,
	"./assets/images/gallery/interiors/lounge.png": 236,
	"./assets/images/gallery/interiors/outdoor-terrace.png": 237,
	"./assets/images/gallery/interiors/thumbs/ensuite.jpg": 238,
	"./assets/images/gallery/interiors/thumbs/fitness-centre.jpg": 239,
	"./assets/images/gallery/interiors/thumbs/kitchen.jpg": 240,
	"./assets/images/gallery/interiors/thumbs/lounge.jpg": 241,
	"./assets/images/gallery/interiors/thumbs/outdoor-terrace.jpg": 242,
	"./assets/images/gallery/neighbourhood/gallery_01.jpg": 243,
	"./assets/images/gallery/neighbourhood/gallery_02.jpg": 244,
	"./assets/images/gallery/neighbourhood/gallery_03.jpg": 245,
	"./assets/images/gallery/neighbourhood/gallery_04.jpg": 246,
	"./assets/images/gallery/neighbourhood/gallery_05.jpg": 247,
	"./assets/images/gallery/neighbourhood/gallery_06.jpg": 248,
	"./assets/images/gallery/neighbourhood/gallery_07.jpg": 249,
	"./assets/images/gallery/neighbourhood/gallery_08.jpg": 250,
	"./assets/images/gallery/neighbourhood/gallery_09.jpg": 251,
	"./assets/images/gallery/neighbourhood/gallery_10.jpg": 252,
	"./assets/images/gallery/neighbourhood/gallery_11.jpg": 253,
	"./assets/images/gallery/neighbourhood/gallery_12.jpg": 254,
	"./assets/images/gallery/neighbourhood/gallery_13.jpg": 255,
	"./assets/images/gallery/neighbourhood/gallery_14.jpg": 256,
	"./assets/images/gallery/neighbourhood/gallery_15.jpg": 257,
	"./assets/images/gallery/neighbourhood/gallery_16.jpg": 258,
	"./assets/images/gallery/neighbourhood/gallery_17.jpg": 259,
	"./assets/images/gallery/neighbourhood/thumbs/gallery_01_thumb.jpg": 260,
	"./assets/images/gallery/neighbourhood/thumbs/gallery_02_thumb.jpg": 261,
	"./assets/images/gallery/neighbourhood/thumbs/gallery_03_thumb.jpg": 262,
	"./assets/images/gallery/neighbourhood/thumbs/gallery_04_thumb.jpg": 263,
	"./assets/images/gallery/neighbourhood/thumbs/gallery_05_thumb.jpg": 264,
	"./assets/images/gallery/neighbourhood/thumbs/gallery_06_thumb.jpg": 265,
	"./assets/images/gallery/neighbourhood/thumbs/gallery_07_thumb.jpg": 266,
	"./assets/images/gallery/neighbourhood/thumbs/gallery_08_thumb.jpg": 267,
	"./assets/images/gallery/neighbourhood/thumbs/gallery_09_thumb.jpg": 268,
	"./assets/images/gallery/neighbourhood/thumbs/gallery_10_thumb.jpg": 269,
	"./assets/images/gallery/neighbourhood/thumbs/gallery_11_thumb.jpg": 270,
	"./assets/images/gallery/neighbourhood/thumbs/gallery_12_thumb.jpg": 271,
	"./assets/images/gallery/neighbourhood/thumbs/gallery_13_thumb.jpg": 272,
	"./assets/images/gallery/neighbourhood/thumbs/gallery_14_thumb.jpg": 273,
	"./assets/images/gallery/neighbourhood/thumbs/gallery_15_thumb.jpg": 274,
	"./assets/images/gallery/neighbourhood/thumbs/gallery_16_thumb.jpg": 275,
	"./assets/images/gallery/neighbourhood/thumbs/gallery_17_thumb.jpg": 276,
	"./assets/images/home/hero.jpg": 277,
	"./assets/images/home/neighbourhood-01-golf.jpg": 278,
	"./assets/images/home/neighbourhood-02-skytrain.jpg": 279,
	"./assets/images/home/neighbourhood-03-twinsails.jpg": 280,
	"./assets/images/interiors/ensuite.jpg": 138,
	"./assets/images/interiors/kitchen.jpg": 139,
	"./assets/images/neighbourhood/arrow-down-gold.svg": 514,
	"./assets/images/neighbourhood/arrow-down.svg": 515,
	"./assets/images/neighbourhood/base_map.png": 516,
	"./assets/images/neighbourhood/close_icon.png": 517,
	"./assets/images/neighbourhood/close_icon.svg": 518,
	"./assets/images/neighbourhood/hero.jpg": 519,
	"./assets/images/neighbourhood/mall.jpg": 520,
	"./assets/images/neighbourhood/map-lg-logo.jpg": 281,
	"./assets/images/neighbourhood/map_base@2x.png": 521,
	"./assets/images/neighbourhood/map_transit.svg": 522,
	"./assets/images/neighbourhood/neighbourhood-1.jpg": 282,
	"./assets/images/neighbourhood/neighbourhood-2.jpg": 283,
	"./assets/images/neighbourhood/plus_icon.png": 523,
	"./assets/images/neighbourhood/plus_icon.svg": 284,
	"./assets/images/neighbourhood/skytrain.jpg": 524,
	"./components/BookAppointment": 285,
	"./components/BookAppointment.js": 285,
	"./components/Button": 11,
	"./components/Button.js": 11,
	"./components/Counter": 286,
	"./components/Counter.js": 286,
	"./components/Footer/Footer": 100,
	"./components/Footer/Footer.js": 100,
	"./components/Footer/sections/Corporate": 102,
	"./components/Footer/sections/Corporate.js": 102,
	"./components/Footer/sections/Project": 101,
	"./components/Footer/sections/Project.js": 101,
	"./components/Gallery": 104,
	"./components/Gallery.js": 104,
	"./components/Header/Header": 97,
	"./components/Header/Header.js": 97,
	"./components/Header/elements/Menu": 99,
	"./components/Header/elements/Menu.js": 99,
	"./components/Header/elements/Nav": 98,
	"./components/Header/elements/Nav.js": 98,
	"./components/Icons/ArrowLeft": 47,
	"./components/Icons/ArrowLeft.js": 47,
	"./components/Icons/ArrowRight": 48,
	"./components/Icons/ArrowRight.js": 48,
	"./components/Intl": 103,
	"./components/Intl.js": 103,
	"./components/Layout/ContentBlock": 16,
	"./components/Layout/ContentBlock.js": 16,
	"./components/Layout/Hero": 26,
	"./components/Layout/Hero.js": 26,
	"./components/Layout/LineCallout": 41,
	"./components/Layout/LineCallout.js": 41,
	"./components/Layout/Title": 18,
	"./components/Layout/Title.js": 18,
	"./components/LoadingScreen": 96,
	"./components/LoadingScreen.js": 96,
	"./components/useIntl": 6,
	"./components/useIntl.js": 6,
	"./config/app.conf": 7,
	"./config/app.conf.js": 7,
	"./config/locales/en": 58,
	"./config/locales/en.js": 58,
	"./config/seo.conf": 17,
	"./config/seo.conf.js": 17,
	"./data/companies": 105,
	"./data/companies.js": 105,
	"./data/developer": 287,
	"./data/developer.js": 287,
	"./data/floorplans": 52,
	"./data/floorplans.js": 52,
	"./data/gallery": 32,
	"./data/gallery.js": 32,
	"./data/map": 79,
	"./data/map.js": 79,
	"./index": 57,
	"./index.js": 57,
	"./pages/Amenities/Amenities": 288,
	"./pages/Amenities/Amenities.js": 288,
	"./pages/Developer/Developer": 289,
	"./pages/Developer/Developer.js": 289,
	"./pages/Developer/elements/Slick": 107,
	"./pages/Developer/elements/Slick.js": 107,
	"./pages/Developer/sections/Companies": 291,
	"./pages/Developer/sections/Companies.js": 291,
	"./pages/Developer/sections/Hero": 106,
	"./pages/Developer/sections/Hero.js": 106,
	"./pages/Floorplans/Floorplans": 292,
	"./pages/Floorplans/Floorplans.js": 292,
	"./pages/Floorplans/elements/Compass": 293,
	"./pages/Floorplans/elements/Compass.js": 293,
	"./pages/Floorplans/elements/Table": 108,
	"./pages/Floorplans/elements/Table.js": 108,
	"./pages/Gallery/Gallery": 294,
	"./pages/Gallery/Gallery.js": 294,
	"./pages/Gallery/elements/Slick": 53,
	"./pages/Gallery/elements/Slick.js": 53,
	"./pages/Gallery/elements/Spotlight": 109,
	"./pages/Gallery/elements/Spotlight.js": 109,
	"./pages/Home/Home": 295,
	"./pages/Home/Home.js": 295,
	"./pages/Home/sections/Hero": 110,
	"./pages/Home/sections/Hero.js": 110,
	"./pages/Interiors/Interiors": 296,
	"./pages/Interiors/Interiors.js": 296,
	"./pages/Interiors/sections/Features": 111,
	"./pages/Interiors/sections/Features.js": 111,
	"./pages/Neighbourhood/Neighbourhood": 297,
	"./pages/Neighbourhood/Neighbourhood.js": 297,
	"./pages/Neighbourhood/elements/List": 114,
	"./pages/Neighbourhood/elements/List.js": 114,
	"./pages/Neighbourhood/elements/Map": 113,
	"./pages/Neighbourhood/elements/Map.js": 113,
	"./pages/Neighbourhood/sections/MapSection": 112,
	"./pages/Neighbourhood/sections/MapSection.js": 112,
	"./pages/NotFound": 298,
	"./pages/NotFound.js": 298,
	"./pages/Privacy": 299,
	"./pages/Privacy.js": 299,
	"./pages/Register/Register": 300,
	"./pages/Register/Register.js": 300,
	"./pages/Register/elements/Checkbox": 117,
	"./pages/Register/elements/Checkbox.js": 117,
	"./pages/Register/elements/Form": 115,
	"./pages/Register/elements/Form.js": 115,
	"./pages/Register/elements/Input": 33,
	"./pages/Register/elements/Input.js": 33,
	"./pages/Register/elements/Radio": 116,
	"./pages/Register/elements/Radio.js": 116,
	"./pages/Register/elements/Select": 54,
	"./pages/Register/elements/Select.js": 54,
	"./pages/Register/sections/RegisterInfo": 118,
	"./pages/Register/sections/RegisterInfo.js": 118,
	"./pages/ThankYou": 301,
	"./pages/ThankYou.js": 301,
	"./plugins/Analytics/Analytics": 89,
	"./plugins/Analytics/Analytics.js": 89,
	"./plugins/Analytics/elements/GTM": 91,
	"./plugins/Analytics/elements/GTM.js": 91,
	"./plugins/Analytics/elements/GTag": 90,
	"./plugins/Analytics/elements/GTag.js": 90,
	"./plugins/Analytics/elements/Hotjar": 92,
	"./plugins/Analytics/elements/Hotjar.js": 92,
	"./plugins/Analytics/elements/Pixel": 93,
	"./plugins/Analytics/elements/Pixel.js": 93,
	"./plugins/OnUpdate": 22,
	"./plugins/OnUpdate.js": 22,
	"./plugins/SEO": 88,
	"./plugins/SEO.js": 88,
	"./plugins/language": 86,
	"./plugins/language.js": 86,
	"./plugins/prerender": 95,
	"./plugins/prerender.js": 95,
	"./plugins/scrollTop": 87,
	"./plugins/scrollTop.js": 87,
	"./plugins/sitemap-generator": 302,
	"./plugins/sitemap-generator.js": 302,
	"./redux/counter": 27,
	"./redux/counter.js": 27,
	"./redux/intl": 38,
	"./redux/intl.js": 38,
	"./redux/load": 39,
	"./redux/load.js": 39,
	"./redux/reducers": 85,
	"./redux/reducers.js": 85,
	"./redux/store": 84,
	"./redux/store.js": 84,
	"./routes": 40,
	"./routes.js": 40,
	"./styles/fonts.css": 157,
	"./styles/global": 83,
	"./styles/global.js": 83,
	"./styles/media": 4,
	"./styles/media.js": 4,
	"./styles/theme": 8,
	"./styles/theme.js": 8,
	"./styles/utils": 1,
	"./styles/utils.js": 1
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 436;